module.exports = __webpack_public_path__ + "img/imagen_parrafo_tres.407153d4.jpg";